import PropTypes from "prop-types";

export default {
  stringOrNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};



// WEBPACK FOOTER //
// ./src/types/customTypes.js